module.exports = __webpack_public_path__ + "static/Resume-78ef8652611ae66aaf9e29b5186379d4.pdf";